// extracted by mini-css-extract-plugin
module.exports = {"popper":"CustomPopper_popper__Dz4vG"};